import EmptyAvatar from "@circle-assets/images/avatar-empty.png";
import { UserImage as UiKitUserImage } from "@circle-react-uikit/UserImage";
import { isNoNamePlaceholder } from "@circle-react-uikit/UserImage/isNoNamePlaceholder";

import type { UserImageProps } from "@/react/components/SettingsApp/CompassCompat/UserImage";

const getUserImageWithFallback = (name: string, src?: string) => {
  const isImageAndNameEmpty = !name && !src;

  if (isImageAndNameEmpty || isNoNamePlaceholder(name)) {
    return EmptyAvatar;
  }

  return src;
};

export const UserImageWithFallback = ({
  hasBorder,
  isFullRounded = true,
  name,
  size,
  src,
  className,
}: UserImageProps & { className?: string }) => {
  const isUserWithoutName = !name?.trim() || isNoNamePlaceholder(name);
  const imgSrc = getUserImageWithFallback(name, src);

  return (
    <UiKitUserImage
      hasBorder={hasBorder}
      isFullRounded={isFullRounded}
      name={isUserWithoutName ? "" : name}
      size={size}
      src={imgSrc}
      className={className}
    />
  );
};
